import styled from "styled-components";
import { VisibilityAnimator } from "components/visibilityAnimator";
import { Expertise } from "components/expertise";
import { Location } from "components/location";
import { Contacts } from "components/contacts";
import { AboutUs } from "components/aboutUs";
import { OurValues } from "components/ourValues";
import { OurServices } from "components/ourServices";
import { WhyChooseUs } from "components/whyChooseUs";
import { Oss } from "components/oss";
import { Apps } from "components/apps";

const StyledBody = styled.div`
  position: relative;
  margin-bottom: 50px;
`;

export const Body = () => {
  return (
    <StyledBody>
      <VisibilityAnimator>
        <AboutUs />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <OurValues />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <OurServices />
      </VisibilityAnimator>
      <VisibilityAnimator zIndex={1}>
        <Expertise />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <Oss />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <Apps />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <WhyChooseUs />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <Contacts />
      </VisibilityAnimator>
      <VisibilityAnimator>
        <Location />
      </VisibilityAnimator>
    </StyledBody>
  );
};
